export default {
  generic_error: 'Something went wrong',
  address_not_found:
    'Sorry, we couldn’t find that address. Please try again by entering first the street in the search address field.',
  internal_error:
    'Unfortunately, there was an unexpected problem with your order, our tech team is already working on it 🛠️.',
};
